import { safeKeys } from 'lib/utils/safeObjectFunctions';

const deleteChildren = (childObj, deleteFn) => safeKeys(childObj).map(deleteFn);

export default deleteChildren;
